import GlobalStyles from './styles/GlobalStyles';
import createTheme from './styles/theme';
import { CURRENCIES, CURRENCY_SYMBOL } from 'common-ui/src/utils/constants';
import { commonInitApp } from 'common-embedded';

const brandObject = {
  country: 'uk',
  brandId: 'avy',
  currencyCode: CURRENCIES.GBP,
  currency: CURRENCY_SYMBOL.GBP,
};

const initApp = commonInitApp({ brandObject, createTheme, GlobalStyles });

export default initApp;